import React from "react";
import { Outlet } from "react-router-dom";

const LayoutBalance = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default LayoutBalance;
